<template>
  <div v-redirect-if-no-permission:PERSONAL_VOUCHERS :key="switch1">
    <loading-component :value="loading" />
    <v-btn color="primary" dark class="mb-2 sbtn" @click="dialog = true">{{ $t("vouchersPage.new") }}</v-btn>
    <DataTable ref="dataTable" :url="'voucher'" :enable-edit="false" :enable-add="false"
      :formatter="formatters" :actions-extra-main="actionsExtraMain" perPage="10"
      :fields-hidden-main="['max_redemption', 'use_times', 'used_amount']" :titles="titles"
      :title='$t("vouchersPage.pageTitlePersonalPending")' :initial-url-search-params="tableParams" />

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card style="padding: 10px;">
        <v-card-title>
          <span class="headline">
            {{ $t("vouchersPage.addVoucherTitle") }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form :key="formKey" ref="addForm">
            <v-text-field :rules="[rules.required]" :label='$t("vouchersPage.title")' type="text" v-model="model.title" />
            <v-text-field :rules="[rules.required]" :label='$t("vouchersPage.code")' type="text" v-model="model.code" />
            <v-select :label='$t("vouchersPage.discountType")' :items="discountTypeItems" :rules="[rules.required]"
              v-model="model.discount_type" />
            <v-text-field :rules="[rules.required, rules.number]" :label='$t("vouchersPage.amount")' type="text" v-model="model.amount" />

            <choose-date :rules="[rules.required]" :label='$t("vouchersPage.startDate")' v-model="model.start_date"></choose-date>
            <choose-date :rules="[rules.required]" :label='$t("vouchersPage.endDate")' v-model="model.end_date"></choose-date>

            <v-autocomplete :rules="[rules.required]" v-model="model.passenger_id" clearable :items="passengers"
              :loading="passengerLoading" :search-input.sync="search" :label='$t("vouchersPage.passenger")' item-text="text"
              item-value="id" :placeholder='$t("vouchersPage.searchPassengerPlaceholder")' cache-items>
              <template slot="item" slot-scope="passengers">
                <v-list-tile-content>
                  <v-list-tile-title v-html="passengers.item.institution || passengers.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="passengers.item.institution ? ((passengers.item.full_name || '') + ' — ' + (passengers.item.username || '')) : passengers.item.username"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" style="width: 50%;" :loading="dialogLoading" flat @click="addVoucher()">{{ $t("vouchersPage.add") }}</v-btn>
          <v-btn color="primary" style="width: 50%;" :loading="dialogLoading" flat
            @click="dialog = false">{{ $t("vouchersPage.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import axios from "axios";
let CancelToken = axios.CancelToken;
let cancel;

export default {
  name: "PersonalPendingVouchers",
  title() {
    return this.$t("vouchersPage.pageTitlePersonalPending");
  },
  components: {
    LoadingComponent,
    DataTable,
    ChooseDate
  },
  data() {
    return {
      formKey: 0,
      rules: {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("vouchersPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("vouchersPage.ruleRequired"),
        number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("vouchersPage.ruleNumber")
      },
      loading: false,
      dialogLoading: false,
      dialog: false,
      passengerLoading: false,
      search: null,
      passengers: [],
      model: {
        title: "",
        code: "",
        discount_type: "PERCENTAGE",
        amount: "",
        start_date: "",
        end_date: "",
        type: "DEDICATED",
        passenger_id: null
      },
      switch1: null,
    };
  },

  computed: {
    formatters() {
      return {
        created_at(value) {
          return value ? formatCompanyTime(value, "YYYY-MM-DD") : "";
        },
        admin_name: (value) => value || this.$t("vouchersPage.system"),
        discount_type: (value) =>
          value == "PERCENTAGE" ? "%" : this.$t("vouchersPage.discountTypeFixed"),
        // FIXED amount is money (divide display by 100); PERCENTAGE is a percent (leave raw).
        amount(value, item) {
          if (item && item.discount_type === "PERCENTAGE") return value;
          if (value === null || value === undefined || value === "") return "—";
          return (Number(value) / 100).toFixed(2);
        },
        type: (value) =>
          value == "DEDICATED"
            ? this.$t("vouchersPage.typeDedicated")
            : this.$t("vouchersPage.typeOnboarding"),
        active(val) {
          return `
                        <i class="v-icon fa ${val ? "fa-check" : "fa-close"
            }"></i>
                        `;
        },
      };
    },
    discountTypeItems() {
      return [
        { text: this.$t("vouchersPage.discountTypePercentage"), value: "PERCENTAGE" },
        { text: this.$t("vouchersPage.discountTypeFixed"), value: "FIXED" },
      ];
    },
    titles() {
      return {
        id: "#",
        title: this.$t("vouchersPage.title"),
        code: this.$t("vouchersPage.code"),
        type: this.$t("vouchersPage.type"),
        discount_type: this.$t("vouchersPage.discountType"),
        amount: this.$t("vouchersPage.amount"),
        start_date: this.$t("vouchersPage.startDate"),
        end_date: this.$t("vouchersPage.endDate"),
        full_name: this.$t("vouchersPage.passenger"),
        admin_name: this.$t("vouchersPage.createdBy"),
        active: this.$t("vouchersPage.active"),
        created_at: this.$t("vouchersPage.creationDate")
      };
    },
    tableParams() {
      const params = new URLSearchParams();
      params.append("pending", true);
      params.append("type", "PERSONAL");
      return params;
    },
    actionsExtraMain() {
      return {

      };
    },

  },
  watch: {
    dialog: function (val) {
      this.dialogLoading = false;
      if (val)
        this.formKey++;
      else
        this.resetModel();


    },
    search(val) {
      // `cache-items` keeps the selected passenger rendered even after the
      // items array is replaced by a new search result, so no guard/merge is
      // needed (this mirrors the working RidesPassengerFilter component).
      if (val === null) return;
      this.passengerLoading = true;
      if (cancel) cancel();
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("search", val);
      this.axios
        .get("passenger/search", {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          this.passengers = res.data.data.map((item) => {
            // Business/institution customers (type HOTEL) are recognised by
            // their establishment name (business_account.name, or the
            // denormalised hotel_name). Surface it so the admin can tell an
            // institution apart from a normal passenger when linking a code.
            const institution =
              (item.business_account && item.business_account.name) ||
              item.hotel_name ||
              "";
            return {
              ...item,
              id: item.id,
              institution,
              text: `${institution ? institution + " - " : ""}${item.full_name || ""} ${item.username || ""}`,
            };
          });
        })
        .catch((err) => console.log(err))
        .finally(() => (this.passengerLoading = false));
    }
  },
  methods: {
    resetModel() {
      this.search = null;
      this.passengers = [];
      this.model = {
        title: "",
        code: "",
        discount_type: "PERCENTAGE",
        amount: "",
        start_date: "",
        end_date: "",
        type: "DEDICATED",
        passenger_id: null
      };
    },
    addVoucher() {

      const form = this.$refs.addForm;
      if (!form.validate()) {
        return;
      }
      this.dialogLoading = true;
      // FIXED amount is money (convert input to stored ×100); PERCENTAGE is a percent (send as typed).
      const payload = {
        ...this.model,
        amount:
          this.model.discount_type === "FIXED"
            ? this.toStoredAmount(this.model.amount)
            : this.model.amount,
      };
      this.axios
        .post(`voucher`, payload)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("vouchersPage.voucherAdded"),
            "green"
          );
          this.dialog = false;
          this.$refs.dataTable.getData();

        })
        .catch((err) => {
          this.dialogLoading = false;
          const errorMessage = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : this.$t("vouchersPage.errorOccurred");
          window.getApp.$emit("SHOW_TOAST", errorMessage, "red");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}

.input {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;

  label {
    font-size: 14px;
  }

  input {
    width: max-content;
    flex-grow: 1;
  }
}
</style>
